import { gql } from '@apollo/client';

export const deleteLivePromptMutation = gql`
  mutation deleteLivePrompt($promptId: ID!, $promptSettingsId: ID!) {
    deleteArticle(where: { id: $promptId }) {
      id
    }

    deletePromptSetting(where: { id: $promptSettingsId }) {
      id
    }
  }
`;
